import React from "react";
import AttendancePage from "./AttendancePage/AttendancePage";
import GrowthPage from "./GrowthPage/GrowthPage";
import HistoryillnessPage from "./HistoryillnessPage/HistoryillnessPage";
import TempaturePage from "./TempaturePage/TempaturePage";
import SelectedField from "../../components/SelectedField";
import {
  feverIcon,
  growthChartIcon,
  immigrationIcon,
  temperatureIcon,
} from "../../assets/icons";
import { Container } from "reactstrap";
export default function ReportRecord() {
  return (
    <Container fluid>
      <SelectedField
        listImage={[
          {
            title: "Tempature",
            image: temperatureIcon,
            page: <TempaturePage />,
          },
          {
            title: "Attendance",
            image: immigrationIcon,
            page: <AttendancePage />,
          },
          {
            title: "History illness",
            image: feverIcon,
            page: <HistoryillnessPage />,
          },
          {
            title: "Growth",
            image: growthChartIcon,
            page: <GrowthPage />,
          },
        ]}
      />
    </Container>
  );
}
